import React, { useEffect } from "react";
import { Table, TableBody, TableCell, TableHead, TablePagination, TableRow } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import HeadCell from "../../table/HeadCell";
import { useApi } from "../../../../../common/hooks";
import { LicenceManagementService } from "../../../../../api";
import { setUpdateLicenceManagement } from "../../../../../common/slice";
import LoadingOverlay from "../../../../../common/components/loaders/LoadingOverlay";
import style from "../UserView.module.css";
import { CustomIconButton, icon } from "../../../../../common/components";
import ViewSearch from "./ViewSearch";
import UserDrawer from "../../user-drawer/UserDrawer";
import ListProjectBU from "./list-project-bu/ListProjectBU";
import { translate } from "../../../../../common/providers";

export default function ViewTable() {
	const licenceManagementStore = useSelector(({ context }) => context.licenceManagement);
	const [openDrawer, setOpenDrawer] = React.useState(false);
	const dispatch = useDispatch();
	const [rowsPerPage, setRowsPerPage] = React.useState(25);
	const [pageDataTable, setPageDataTable] = React.useState(0);
	const [isLoading, setIsLoading] = React.useState(false);
	const { call: getListBUByUser } = useApi(LicenceManagementService.getListBUByUser);
	const getBodyTable = (params) => {
		setIsLoading(true);
		getListBUByUser(params)
			.then((data) => {
				setIsLoading(false);
				dispatch(setUpdateLicenceManagement({ companiesByUser: data }));
			})
			.catch((e) => {
				console.error(e);
				setIsLoading(false);
			});
	};
	const preparePayload = () => ({
		buName: licenceManagementStore.searchCompaniesByUser,
		sort: licenceManagementStore.sortCompaniesByUser,
		direction: licenceManagementStore.directionCompaniesByUser,
		active: licenceManagementStore.search.active,
	});

	useEffect(() => {
		const payload = preparePayload();
		const params = {
			page: pageDataTable,
			limit: rowsPerPage,
			payload,
			userId: licenceManagementStore?.selectedUser?.id,
		};
		getBodyTable(params);

		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [
		licenceManagementStore?.searchCompaniesByUser,
		licenceManagementStore.selectedUser,
		licenceManagementStore?.sortCompaniesByUser,
		licenceManagementStore.directionCompaniesByUser,
		licenceManagementStore?.search.active,
		licenceManagementStore?.refresh,
	]);
	const handleChangePage = (event, newPage) => {
		setPageDataTable(newPage);

		const payload = preparePayload();
		const params = {
			page: newPage,
			limit: rowsPerPage,
			userId: licenceManagementStore?.selectedUser?.id,
			payload,
		};

		getBodyTable(params);
	};

	const handleChangeRowsPerPage = (event) => {
		setRowsPerPage(+event.target.value);
		setPageDataTable(0);

		const payload = preparePayload();
		const params = {
			page: 0,
			limit: event.target.value,
			payload,
			userId: licenceManagementStore?.selectedUser?.id,
		};
		getBodyTable(params);
	};
	const handelUpdateSort = (item) => {
		dispatch(
			setUpdateLicenceManagement({
				sortCompaniesByUser: item,
				directionCompaniesByUser: licenceManagementStore?.sortCompaniesByUser === "ASC" ? "DESC" : "ASC",
			})
		);
	};

	const handelOpenDrawer = () => {
		dispatch(setUpdateLicenceManagement({ refresh: false }));
		setOpenDrawer(true);
	};
	const handelCloseDrawer = () => {
		setOpenDrawer(false);
		dispatch(setUpdateLicenceManagement({ refresh: true }));
	};
	const handelSelectedBu = (company) => {
		dispatch(
			setUpdateLicenceManagement({
				companySelected: company,
			})
		);
		handelOpenDrawer();
	};

	return (
		<div>
			{isLoading && <LoadingOverlay />}
			<ViewSearch />
			<div className={style.tableContainer}>
				<Table className={style.table}>
					<TableHead className={style.tableHead}>
						<HeadCell
							cell={{ name: translate("license-management.view-table.territory") }}
							className={style.cell}
							onClick={() => handelUpdateSort("name")}
						/>
						<HeadCell
							hiddenSort
							cell={{ name: translate("common:licence-management.title.status") }}
							className={style.cellStatus}
							onClick={() => handelUpdateSort("status")}
						/>
						<TableCell className={style.cellAction} />
					</TableHead>
					<TableBody>
						{licenceManagementStore?.companiesByUser?.contents?.map((c) => (
							<TableRow>
								<TableCell className={`${style.tableCellRow} ${style.noBorderLeft}`}>
									{" "}
									{c?.companyName}
								</TableCell>
								<TableCell className={style.tableCellRow}>
									{/* eslint-disable-next-line no-nested-ternary */}
									{(c?.userRole &&
										c?.authorized === "ACTIVE" &&
										translate("common:licence-management.status.allowed")) ||
										translate("common:licence-management.status.unAllowed") ||
										""}
								</TableCell>
								<TableCell className={`${style.tableCellRow} ${style.noBorderRight}`}>
									{c?.userRole && (
										<CustomIconButton
											icon={icon.faList}
											size="xs"
											tooltip={translate("common:licence-management.btn.hover.list-contract")}
											variant="outlined"
											onClick={() => {
												handelSelectedBu(c);
											}}
										/>
									)}
								</TableCell>
							</TableRow>
						))}
					</TableBody>
				</Table>
			</div>
			<div className={style.paginationContainer}>
				<TablePagination
					component="div"
					count={licenceManagementStore?.companiesByUser?.totalElements}
					labelRowsPerPage={translate("common:pagination.row-per-page")}
					page={pageDataTable}
					rowsPerPage={rowsPerPage}
					rowsPerPageOptions={[25, 50, 75]}
					onPageChange={handleChangePage}
					onRowsPerPageChange={handleChangeRowsPerPage}
				/>
			</div>

			<UserDrawer
				hiddenAction
				childrens={<ListProjectBU />}
				closeDrawer={handelCloseDrawer}
				onclick={handelCloseDrawer}
				open={openDrawer}
				title={`${translate("common:licence-management.project-list.title")} - ${
					licenceManagementStore?.companySelected?.companyName
				}`}
			/>
		</div>
	);
}
